import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import Label from '@components/form/Label';
import { Box } from '@components/layout/Grid';
import Link from '@components/Link';
import { CardDescription } from '@components/texts';
import ThumbnailWithRatio, { Image } from '@components/ThumbnailWithRatio';

const Card = styled.div`
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;

  ${Image} {
    object-fit: contain;
  }
`;

const BlogItemCard = props => {
  return (
    <Card className={props.className}>
      <Box mb={20}>
        <Link href={props.redirectUrl}>
          <ThumbnailWithRatio path={props.thumbnailUrl} objectFit="contain" />
        </Link>
      </Box>
      <Box mb={10}>
        <Label>{props.title}</Label>
      </Box>
      <Box
        mb="10px"
        style={
          props.noTrancate
            ? {}
            : {
                height: '38px',
              }
        }
      >
        <CardDescription
          dangerouslySetInnerHTML={{
            __html: props.description.substr(0, 300).replace(/<img[^>]*>/g, ''),
          }}
        />
      </Box>
      <Box className="ReadMore--btn">
        <Link href={props.redirectUrl} bold>
          <Trans id="metadata.read_more" message={'Read more'} />
        </Link>
      </Box>
    </Card>
  );
};

export { Label, CardDescription };
export default BlogItemCard;
